"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPaletteConfigToCssVars = exports.paletteValueToCssVar = exports.paletteConfigToCssVars = exports.paletteAliasToCssVar = void 0;
var _cdsCommon = require("@cbhq/cds-common");
var _cdsUtils = require("@cbhq/cds-utils");
/**
 * `Please don't use this unless you absolutely have to. This is meant as last resort.`
 * Takes a palette value and returns the rgb or rgba string with interpolated css variables.
 * @param paletteValue - 'gray0'
 * @returns rgb or rgba string - rgb(var(--gray0))
 */
const paletteValueToCssVar = paletteValue => {
  const _ref = typeof paletteValue === 'string' ? [paletteValue] : paletteValue,
    alias = _ref[0],
    opacity = _ref[1];
  const cssVariable = (0, _cdsUtils.toCssVarFn)(alias);
  if (opacity !== undefined) {
    return `rgba(${cssVariable},${opacity})`;
  }
  return `rgb(${cssVariable})`;
};

/**
 * Given a palette alias, such as foregroundMuted, and the spectrum, it will output the rgb or rgba string with interpolated css variables.
 * @param palette - foregroundMuted, foreground, background etc...
 * @returns rgb or rgba string - rgb(var(--gray0))
 */
exports.paletteValueToCssVar = paletteValueToCssVar;
const paletteAliasToCssVar = palette => {
  return paletteValueToCssVar(_cdsCommon.defaultPalette[palette]);
};

/**
 * `Please don't use this unless you absolutely have to. This is meant as last resort.`
 * Takes a palette config and returns an object to access computed color values based on config.
 * @param paletteConfig  - { background: 'gray0' }
 * @returns { background: 'rgb(var(--gray0))' }
 */
exports.paletteAliasToCssVar = paletteAliasToCssVar;
const paletteConfigToCssVars = paletteConfig => {
  const config = Object.assign({}, _cdsCommon.defaultPalette, paletteConfig);
  return (0, _cdsUtils.mapValues)(config, paletteValue => paletteValueToCssVar(paletteValue));
};

/**
 * Takes a palette config and returns an object to attach as inline style to assign css variables.
 * @param paletteConfig - { background: 'gray0' }
 * @returns { '--background': 'rgb(var(--gray0))' }
 */
exports.paletteConfigToCssVars = paletteConfigToCssVars;
const setPaletteConfigToCssVars = paletteConfig => {
  return (0, _cdsUtils.mapKeys)(paletteConfigToCssVars(paletteConfig), (_, key) => (0, _cdsUtils.toCssVar)(key));
};
exports.setPaletteConfigToCssVars = setPaletteConfigToCssVars;